import { render, staticRenderFns } from "./modal_registrar_proveedor.vue?vue&type=template&id=5cb16191&"
import script from "./modal_registrar_proveedor.vue?vue&type=script&lang=js&"
export * from "./modal_registrar_proveedor.vue?vue&type=script&lang=js&"
import style0 from "./modal_registrar_proveedor.vue?vue&type=style&index=0&id=5cb16191&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports